import React from 'react';

export const TableNote = ({ theme, density, note, palette }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const e = theme.effects || {};

  return (
    <div style={{
      position: 'relative',
      padding: '12px 14px 14px 18px',
      background: note.pinned ? palette.bg : 'rgba(0,0,0,0.22)',
      borderRadius: e.borderRadiusSm || '6px',
      marginBottom: density.spacing.itemGap,
      borderLeft: `3px solid ${palette.color}`,
      fontFamily: t.fontFamily,
      boxShadow: note.pinned ? `0 0 16px ${palette.glow}` : 'none',
    }}>
      {note.pinned && (
        <span style={{
          position: 'absolute', top: 10, right: 12,
          fontSize: '0.95rem',
          filter: `drop-shadow(0 0 6px ${palette.color})`,
        }}>📌</span>
      )}
      <div style={{
        color: c.textPrimary,
        fontWeight: 700,
        fontSize: '0.9rem',
        marginBottom: 4,
        paddingRight: 24,
      }}>{note.title}</div>
      <div style={{ color: c.textSecondary, fontSize: '0.82rem', marginBottom: 10, lineHeight: 1.45 }}>
        {note.body}
      </div>
      <div style={{ fontSize: '0.72rem', display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ color: palette.light, fontWeight: 700 }}>{note.author}</span>
        <span style={{ color: c.textMuted }}>· {note.campaignName} · {note.timeAgo}</span>
      </div>
    </div>
  );
};
